window.BotDetection = (function() {

	if (!sessionStorage.getItem('session_start')) {
		sessionStorage.setItem('session_start', Date.now());
	}

	function markView(productId) {
		if (!productId) return;
		const key = `pdp_view_${productId}`;
		if (!sessionStorage.getItem(key)) {
			sessionStorage.setItem(key, Date.now());
		}
	}

	document.addEventListener('DOMContentLoaded', function() {
		const productPage = document.querySelector('[data-js-product-component]');
		if (productPage) {
			markView(productPage.dataset.id);
		}
	});

	function getScore(productId, form) {
		let score = 0;
		let deltaSeconds = null;

		if (productId) {
			const viewedAt = sessionStorage.getItem(`pdp_view_${productId}`);
			deltaSeconds = viewedAt ? Math.round((Date.now() - viewedAt) / 1000) : null;
			if (deltaSeconds !== null && deltaSeconds < 2) {
				score++;
			}
		}

		const honeypot = form ? form.querySelector('[data-js-honeypot]') : null;
		if (honeypot && honeypot.value !== '') {
			score++;
		}

		return { score, deltaSeconds };
	}

	return { getScore, markView };

})();